const UtilisationAndAttendanceIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
        fill="#9966FB"
      />
      <path
        d="M19.3 20.7L20.7 19.3L17 15.6V11H15V16.4L19.3 20.7ZM16 26C14.6167 26 13.3167 25.7375 12.1 25.2125C10.8833 24.6875 9.825 23.975 8.925 23.075C8.025 22.175 7.3125 21.1167 6.7875 19.9C6.2625 18.6833 6 17.3833 6 16C6 14.6167 6.2625 13.3167 6.7875 12.1C7.3125 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.3125 12.1 6.7875C13.3167 6.2625 14.6167 6 16 6C17.3833 6 18.6833 6.2625 19.9 6.7875C21.1167 7.3125 22.175 8.025 23.075 8.925C23.975 9.825 24.6875 10.8833 25.2125 12.1C25.7375 13.3167 26 14.6167 26 16C26 17.3833 25.7375 18.6833 25.2125 19.9C24.6875 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6875 19.9 25.2125C18.6833 25.7375 17.3833 26 16 26ZM16 24C18.2167 24 20.1042 23.2208 21.6625 21.6625C23.2208 20.1042 24 18.2167 24 16C24 13.7833 23.2208 11.8958 21.6625 10.3375C20.1042 8.77917 18.2167 8 16 8C13.7833 8 11.8958 8.77917 10.3375 10.3375C8.77917 11.8958 8 13.7833 8 16C8 18.2167 8.77917 20.1042 10.3375 21.6625C11.8958 23.2208 13.7833 24 16 24Z"
        fill="white"
      />
    </svg>
  )
}

export default UtilisationAndAttendanceIcon
